import { Routes } from '@angular/router';
import { RoleListComponent } from './role-list/role-list.component';
import { CreateRoleComponent } from './create-role/create-role.component';
import { RoleDetailComponent } from './role-detail/role-detail.component';
import { RoleEditComponent } from './role-edit/role-edit.component';

export const rolesRoutes: Routes = [
  {
    path: '',
    component: RoleListComponent,
  },
  {
    path: 'create',
    component: CreateRoleComponent,
  },
  {
    path: ':id',
    component: RoleDetailComponent,
  },
  {
    path: ':id/edit',
    component: RoleEditComponent,
  },
];
